<section class="header-panel">
  <div class="header-panel-content">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="breadcrumb-content">
            <div class="section-heading">
              <h1 class="section__title">{{title}}</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <img src="/assets/icons/wave.svg" class="image-wave" alt="">
</section>